// Left-arrow glyph for buttons that navigate back (tutorial → game, selector →
// game, creator → grids). Lives here because IconButton.back() is its only user.
const BACK_ICON = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';

/**
 * A sidebar icon-button whose label + glyph swap between a default state and a
 * "Back to …" state. Bundles the button, its label/glyph child elements, and the
 * captured default glyph so callers say `grids.back('Back to Grids')` /
 * `grids.reset('Grids')` instead of threading those elements through a helper.
 *
 * Only the four buttons that double as in-modal back controls (Grids, Help,
 * Settings, Leaderboard) use this; plain buttons stay as raw elements.
 */
export class IconButton {
    readonly btn: HTMLButtonElement;
    private readonly labelEl: HTMLElement;
    private readonly glyphEl: HTMLElement;
    private readonly glyphDefault: string;

    constructor(id: string) {
        this.btn = document.getElementById(id) as HTMLButtonElement;
        this.labelEl = this.btn.querySelector('.icon-btn-label') as HTMLElement;
        this.glyphEl = this.btn.querySelector('.icon-btn-glyph') as HTMLElement;
        this.glyphDefault = this.glyphEl.innerHTML;
    }

    /** Show the back-arrow glyph with a (wrapping) label — the button is acting
     *  as a "Back to …" control inside a modal. */
    back(label: string): void {
        this.set(label, BACK_ICON, true);
    }

    /** Restore the button's default glyph and the given label. */
    reset(label: string): void {
        this.set(label, this.glyphDefault, false);
    }

    private set(label: string, glyphHtml: string, isBack: boolean): void {
        this.labelEl.textContent = label;
        this.glyphEl.innerHTML = glyphHtml;
        this.labelEl.classList.toggle('back', isBack);
    }
}
